module.exports = __webpack_public_path__ + "img/ic24Search.89454388.svg";